export default {
    getForm(state) {
        return state.form
    }
}
